import { AutogenLayoutRenditionPropertyList } from "./autogen/AutogenLayoutRenditionPropertyList";
import {  DataSourceExecutionEvent } from "@mcleod/components";

export class RenditionPropertyList extends AutogenLayoutRenditionPropertyList {

/** This is an event handler for the beforeExecution event of sourceRenditionProperties. */
  sourceRenditionPropertiesBeforeExecution(event: DataSourceExecutionEvent) {

  }
}
